import React from 'react';
import DateRangePicker, { DateRangeInput } from 'components/DateRangePicker/DateRangePicker';
import { DatePeriod, DATE_PRESET_OPTIONS } from 'models/calendar';
import { MeteringPoint } from 'models/electricity/metering-point';
import { IOptions } from 'common/reactSelectModels';
import MeteringPointSelect from 'components/electricity/MeteringPointSelect';


interface ElectricityConsumptionSearchBarProps {
    period: DatePeriod | DateRangeInput;
    setPeriod: (period: DatePeriod | DateRangeInput) => void;
    selectedMeteringPoint?: IOptions;
    setSelectedMeteringPoint: (meteringPoint: IOptions) => void;
    meteringPoints: MeteringPoint[];
}

export default function ElectricityConsumptionSearchBar(props: ElectricityConsumptionSearchBarProps) {

    const onDatesChange = (dates: DateRangeInput) => {
        const period = DATE_PRESET_OPTIONS.find(o => o.id === dates.selectedOptionId);
        props.setPeriod(period ?? dates);
    }
 
    return (
        <div className="bar-position">
            <h2>
                Elektritarbimine
            </h2>
            <div className="card p-0 mb-5">
                <div className="card-body">
                    <div className='d-flex flex-wrap flex-md-nowrap flex-column flex-md-row document-rows__search-bar align-items-center'>
                        <div className="mw-240-px mr-md-4 mr-0 filter">
                            <DateRangePicker 
                                startDate={props.period.startDate}
                                endDate={props.period.endDate}
                                onChange={onDatesChange}
                                selectedOptionId={(props.period as DatePeriod).id}
                                dateOptions={DATE_PRESET_OPTIONS}
                            />
                        </div>
                        <MeteringPointSelect 
                            meteringPoints={props.meteringPoints}
                            selectedMeteringPoint={props.selectedMeteringPoint}
                            onMeteringPointChange={props.setSelectedMeteringPoint}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

